import React, { Component } from 'react';
import {auth} from '../../app-firebase/firebase';
// import ReactLoading from 'react-loading';
import store from '../../redux/store/store';
import Book from '../../objects/Book';
import Media from '../../objects/Media';
import SheetMusic from '../../objects/SheetMusic';
import { db, storage } from '../../app-firebase/firebase';
import { TiWarningOutline } from 'react-icons/ti';
import { AiOutlineCheck } from 'react-icons/ai';
import ProductForm from './ProductForm';
// import $ from 'jquery';

import categories from "../../objects/categories";

class LoggedAdmin extends Component {
   constructor(props) {
      super(props);

      this.state = {
         operation: 'add',
      }
      this.logout = setInterval(() => {
         auth.signOut();
      }, 1000000);
   }


   componentDidMount() {
      document.getElementById('logged').addEventListener('click', e => {
         clearInterval(this.logout);
         this.logout = setInterval(() => {
            auth.signOut();
         }, 1000000);
      })
   }

   componentDidUpdate() {
      
   }

   componentWillUnmount() {
      document.removeEventListener('click', e => {})
   }






   addProductToDatabase(e) {
      console.log('this.isbns.includes(this.state.isbn): ', this.existingIpNumbers.includes(this.state.isbn));
      e.preventDefault();
      if (this)
      // Add error messages to a list for any unprovided required data
      if (!this.state.isbn || this.existingIpNumbers.includes(this.state.isbn) || !this.state.title || !this.state.category || !this.state.priceCad || !this.state.priceUsd) {
         const errorMessages = [];
         if (!this.state.isbn) errorMessages.push('ISBN must be provided');
         if (this.existingIpNumbers.includes(this.state.isbn)) errorMessages.push('ISBN provided already exists');
         if (!this.state.title) errorMessages.push('Title must be provided');
         if (!this.state.category) errorMessages.push('Category must be provided');
         if (!this.state.priceCad) errorMessages.push('canadian price must be provided');
         if (!this.state.priceUsd) errorMessages.push('American price must be provided');
         this.setState({
            errorMessages
         })
      }
      // Create the objects and add it into the database
      else {
         if (this.getDataConfirmation()) {
         const desc = document.querySelectorAll('textarea.add-form-desc');
         const ps = Object.values(desc).map(el => {
            return el.value ? el.value : null;
         });

         const tracks = [];
         if (this.state.type === 'cd' || this.state.type === 'dvd' || this.state.type === 'cassette') {
            for (let i = 1; i <= this.state.tracks; i++) {
               const track = {
                  author: document.querySelector('#add-form-tracks-author' + i).value,
                  number: i,
                  title: document.querySelector('#add-form-tracks-title' + i).value
               }
               if (!track.title && !track.author) {
                  continue;
               }
               tracks.push(track);
            }
         }

         const performers = [];
         if (this.state.type === 'cd' || this.state.type === 'dvd' || this.state.type === 'cassette') {
            for (let i = 1; i <= this.state.performers; i++) {
               const performer = {
                  name: document.querySelector('#add-form-performers-name' + i).value,
                  role: document.querySelector('#add-form-performers-role' + i).value
               }
               if (!performer.name) {
                  continue;
               }
               performers.push(performer);
            }
         }


         let product = null;
         switch (this.state.type) {
            case 'book':
               product = new Book(this.state.isbn, this.state.category, this.state.title, this.state.subtitle, ps, this.state.author, this.state.subject, this.state.priceCad, this.state.priceUsd, this.state.image, this.state.timeAbout);
               break;
         
            case 'cd':
            case 'dvd':
            case 'cassette':
               product = new Media(this.state.isbn, this.state.category, this.state.title, this.state.subtitle, ps, this.state.author, this.state.subject, this.state.priceCad, this.state.priceUsd, this.state.image, performers, this.state.number, this.state.totalTime, tracks, this.state.language, this.state.type);
               break;

            case 'sheet music':
               product = new SheetMusic(this.state.isbn, this.state.title, this.state.subtitle, ps, this.state.author, this.state.subject, this.state.priceCad, this.state.priceUsd, this.state.number, this.state.image);
               break;
            default:
               throw new Error('inexistent product type' + this.state.type);
         }
         
         db.ref(this.state.type !== 'sheet music' ? this.state.type + 's/' + this.state.isbn : 'sheets/' + this.state.isbn).set(product, (err) => {
            console.log('Connecting to the database...')
            if (err) {
               this.setState({
                  errorMessages: [...this.state.errorMessages, err.message]
               });
            } else {
               const file = document.querySelector('#add-form-image').files[0];
               if (file) {
                  let prefix = '';
                  if (this.state.type === 'sheet music' || this.state.type === 'cassette') {
                     if (this.state.type === 'sheet music') prefix = 'sheets/'
                     else prefix = 'cds/';
                  } else {
                     prefix = this.state.type + 's/'
                  }
                  const ref = storage.ref(prefix).child(file.name);
                  const uploadTask = ref.put(file);

                  uploadTask.on('state_changed', snapshot => {

                  }, error => {
                     console.log(error);
                  }, () => {
                     console.log('Image uploaded with success')
                  })
               }
               this.setState({
                  showConfirmation: true,
                  error: false,
                  errorMessages: [],
                  isIsbnExistent: false,
                  resetInputs: true,
                  isbn: '',
                  title: '',
                  subtitle: '',
                  category: '',
                  subject: '',
                  author: '',
                  image: '',
                  priceUsd: '',
                  priceCad: '',
                  timeAbout: '',
                  descParagraphs: 0,
                  tracks: 0,
                  performers: 0
               }, () => this.setState({
                  resetInputs: false,
                  descParagraphs: 1,
                  tracks: 1,
                  performers: 1
               }))
               console.log('Book added with success!');
               setTimeout(() => {
                  this.setState({
                     showConfirmation: false
                  });
               }, 10000);
            }
         });
      
      }
   }
   }






   



   handleSetOperation(e, operation) {
      e.preventDefault();
      if (operation !== this.state.operation) {
         this.setState({
            operation,
            type: '',
            searchBy: ''
         }, () => {
            // document.querySelector('#a-type-select').value = '';
         });
      }
   }



   render() {

      return (
         <div id="logged" className="logged">
            <div className="logged-form d-flex logged-bar justify-content-between">
               <p>Hi, Bruno!</p>
               <button className="btn btn-light" onClick={() => auth.signOut()}>Sign Out</button>
            </div>
            <div className="logged-main d-flex">
               <aside className="">
                  <div style={{fontWeight: 'bold'}}>
                     Database
                  </div>
                  <div>
                     <button className="btn btn-link" onClick={(e) => this.handleSetOperation(e, 'add')} style={this.state.operation === 'add' ? {color: '#0056b3', textDecoration: 'underline'} : {}}>Add product</button>
                  </div>
                  <div>
                     <button className="btn btn-link" onClick={(e) => this.handleSetOperation(e, 'update')} style={this.state.operation === 'update' ? {color: '#0056b3', textDecoration: 'underline'} : {}}>Update product</button>
                  </div>
                  <div>
                     <button className="btn btn-link" onClick={(e) => this.handleSetOperation(e, 'remove')} style={this.state.operation === 'remove' ? {color: '#0056b3', textDecoration: 'underline'} : {}}>Remove product</button>
                  </div>
               </aside>
               {this.state.operation === 'add' || this.state.operation === 'update'?
                  <div className="form-section p-4">
                     <ProductForm operation={this.state.operation}/>
                  </div> :
                  null
               }
            </div>
         </div>
      );
   }
}

export default LoggedAdmin
